import React from 'react';
import { Redirect, RouteProps } from 'react-router';

import RouteWithSearch from './route-with-search';

export interface Props extends RouteProps {
    param: string;
}

// Redirect urls with given query param (used for deprecated params) to urls without it
// Keep other query params and return RouteWithSearch for urls without it
export default (props: Props) => {
    const { param, ...rest } = props;
    if (props.location && props.location.search && props.location.search.indexOf(`${param}=`) !== -1) {
        const queryParams = props.location.search.slice(1).split('&');
        const newQueryParams = queryParams.filter(item => item.indexOf(`${param}=`) === -1);

        let newQueryParamsStr = '';
        if (newQueryParams.length) {
            newQueryParamsStr = '?' + newQueryParams.join('&');
        }
        return <Redirect to={props.location.pathname + newQueryParamsStr} />;
    }

    return <RouteWithSearch {...rest} />;
};

